import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Redirect } from 'react-router';
import { FormattedMessage, injectIntl } from 'react-intl';
import {
  Row, Col, Button, Label, Input, Alert, Card, CardHeader, CardBody, Form, FormGroup, FormText,
} from 'reactstrap';
import { updateMe } from '../../utils/Api';

const mapStateToProps = ({ user }) => ({
  permissions: user.permissions || [],
});

class ChangePassword extends Component {
  constructor(props) {
    super(props);

    this.state = {
      password: '',
      confirmPassword: '',
      errorMessage: '',
      finished: false,
    };

    this.submit = this.submit.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange({ target }) {
    this.setState({ errorMessage: '', [target.id]: target.value });
  }

  submit() {
    const { password, confirmPassword } = this.state;
    if (!password) {
      this.setState({ errorMessage: 'profile__fillPassword' });
    } else if (!confirmPassword) {
      this.setState({ errorMessage: 'profile__fillConfirm' });
    } else if (password !== confirmPassword) {
      this.setState({ errorMessage: 'profile__doesNotMatch' });
    } else {
      updateMe({ password }).then((r) => {
        this.setState(r.error && r.error.msg ? { errorMessage: r.error.msg } : { finished: true });
      });
    }
  }

  render() {
    const { intl, permissions } = this.props;
    if (!permissions.includes('LEARNING_CHANGE_PASSWORD')) {
      return null;
    }

    const { password, confirmPassword, errorMessage, finished } = this.state;
    if (finished) {
      return <Redirect to="/" />;
    }

    return (
      <div className="animated fadeIn">
        <Row>
          <Col xs="12">
            <Card className="mrg-b-none">
              <CardHeader><FormattedMessage id="header_profile_changePassword" /></CardHeader>
              <CardBody>
                <Form action="" method="post" encType="multipart/form-data" className="form-horizontal">
                  <FormGroup row>
                    <Col md="3"><Label htmlFor="password-input"><FormattedMessage id="profile__password" /></Label></Col>
                    <Col xs="12" md="9">
                      <Input
                        type="password"
                        id="password"
                        autoComplete="new-password"
                        placeholder={intl.formatMessage({ id: 'profile__password' })}
                        value={password}
                        onChange={this.handleChange}
                      />
                      <FormText className="help-block"><FormattedMessage id="profile__enterComplex" /></FormText>
                    </Col>
                  </FormGroup>
                  <FormGroup row>
                    <Col md="3"><Label htmlFor="password-input"><FormattedMessage id="profile__confirmPassword" /></Label></Col>
                    <Col xs="12" md="9">
                      <Input
                        type="password"
                        id="confirmPassword"
                        autoComplete="new-password"
                        placeholder={intl.formatMessage({ id: 'profile__confirmPassword' })}
                        value={confirmPassword}
                        onChange={this.handleChange}
                      />
                    </Col>
                  </FormGroup>
                </Form>
                {errorMessage && <Alert color="danger"><FormattedMessage id={errorMessage} /></Alert>}
                <Col xs="12" className="pb-3 input-group">
                  <Button onClick={this.submit} color="primary" size="lg" className="ml-auto">
                    <FormattedMessage id="overall_input_change" />
                  </Button>
                </Col>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

ChangePassword.propTypes = {
  intl: PropTypes.objectOf(PropTypes.any).isRequired,
  permissions: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default connect(mapStateToProps)(injectIntl(ChangePassword));



// WEBPACK FOOTER //
// ./src/views/_Profile/ChangePassword.js